const fetchUser = 'FetchUser{user{type, readNotifications, acceptedAdv, isAccountOwner, email,id,phone,permissions,firstName,lastName,email,type, account{type, acceptedTerms, company{id,name}, billingAddress{billingDetailsComplete},isOnTrial,trialEnd, mainSubscription{ends, expired} }}}';

export const queries = {
    fetchUser
};
